import { render, staticRenderFns } from "./Loadingscreen.vue?vue&type=template&id=032b4ee4&scoped=true"
import script from "./Loadingscreen.vue?vue&type=script&lang=js"
export * from "./Loadingscreen.vue?vue&type=script&lang=js"
import style0 from "./Loadingscreen.vue?vue&type=style&index=0&id=032b4ee4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032b4ee4",
  null
  
)

export default component.exports